import React from "react";

import date from "date-and-time";

import { StarIcon } from "@heroicons/react/solid";

import Card from "../Shared/Card/Card";
import { DetailRow } from "./DetailRow";
import { IPerson } from './../../models/person/Person';

interface LeadInformationProfileProps extends Partial<IPerson> { }

export function LeadInformation({ created, updated, leadScore, personSources, salesApplicantProfile, lettingsApplicantProfile, landlordProfile, tenantProfile }: LeadInformationProfileProps) {

  const getClientType = () => {
    let clientTypes: string[] = [];

    if (salesApplicantProfile) {
      clientTypes.push("Sales Applicant");
    }

    if (lettingsApplicantProfile) {
      clientTypes.push("Lettings Applicant");
    }

    if (landlordProfile) {
      clientTypes.push("Landlord");
    }

    if (tenantProfile) {
      clientTypes.push("Tenant");
    }

    return clientTypes.length > 0 ? clientTypes.join(" & ") : "Unknown";
  }

  const getLeadSource = () => {
    console.log("personSources:", personSources);
    if (!personSources || personSources.length === 0 || !personSources[0].source) return "Unknown";

    return personSources.map(source => source.source).join(", ");
  }

  return (
    //@ts-ignore
    <Card title="Lead Information" className="mt-4">
      <div className="grid grid-cols-1 gap-4 ml-2">
        <dl className="text-sm divide-y my-2 divide-gray-100">
          <DetailRow label="Created On" value={date.format(
            new Date(created!),
            "DD/MM/YYYY HH:mm"
          )} />
          <DetailRow label="Client Type" value={getClientType()} />
          <DetailRow label="Updated On" value={date.format(
            new Date(updated!),
            "DD/MM/YYYY HH:mm"
          )} />
          <DetailRow
            label="Lead Score"
            value={
              <div className="flex flex-row items-center "><span className="mr-4">{leadScore?.toString() ?? "Unknown"}</span>
                {Array(5).fill(0).map((_, i) =>
                  <StarIcon className={`w-5 h-5 ${i < (leadScore ?? 0) ? "text-etpink-500" : "text-gray-300"}`} key={i} />
                )}
              </div>
            }
          />
          <DetailRow label="Lead Source" value={getLeadSource()} />
        </dl>
      </div>
    </Card>
  )

}